// Series colours for multi-line charts (Eric, 2026-10-18): the polaris-viz default runs through blues and purples,
// so neighbouring lines are hard to tell apart. The first eight are the Okabe–Ito colour-blind-safe set, in an order
// that alternates warm and cool; the rest keep going with clearly different hues. Assigned by series position.
export const SERIES_COLORS = [
    '#0072B2', '#E69F00', '#009E73', '#D55E00', '#CC79A7', '#56B4E9', '#4D4D4D', '#B8860B',
    '#8E44AD', '#1ABC9C', '#C0392B', '#2C3E50', '#F39C12', '#27AE60', '#E84393', '#7F8C8D',
    '#6C5CE7', '#D35400', '#16A085', '#2980B9',
];
export const seriesColor = i => SERIES_COLORS[i % SERIES_COLORS.length];
// attach a colour to each series (keeps any colour already set)
export const withColors = list => list.map((s, i) => (s.color ? s : { ...s, color: seriesColor(i) }));
